import { memo } from 'react';
import {
  getIn,
  Field,
  connect as connectFormik,
  FieldProps,
  FieldArray,
  FormikProps,
} from 'formik';

import Input from 'components/Input';
import ButtonGroup from 'components/ButtonGroup';

import { definedTypes } from '../Messages';
import { Types, Sizes, FileWrapper } from '../styles';
import { IFormValues } from 'store/survey/surveyTypes';
import i18n from '../../../../../../../i18n';

interface IFormikConnect {
  formik: FormikProps<IFormValues>;
}

const sizeItems = {
  128: i18n.t('getKB', { ns: 'taskManager', size: 128 }),
  256: i18n.t('getKB', { ns: 'taskManager', size: 256 }),
  512: i18n.t('getKB', { ns: 'taskManager', size: 512 }),
  1024: i18n.t('getMB', { ns: 'taskManager', size: 1 }),
  5120: i18n.t('getMB', { ns: 'taskManager', size: 5 }),
  10240: i18n.t('getMB', { ns: 'taskManager', size: 10 }),
  15360: i18n.t('getMB', { ns: 'taskManager', size: 15 }),
  20480: i18n.t('getMB', { ns: 'taskManager', size: 20 }),
  51200: i18n.t('getMB', { ns: 'taskManager', size: 50 }),
  102400: i18n.t('getMB', { ns: 'taskManager', size: 100 }),
  204800: i18n.t('getMB', { ns: 'taskManager', size: 200 }),
};

const FileFieldsEditor: React.FC<IFormikConnect> = ({ formik: { values } }) => {
  const maxSize = getIn(values, ['data', 'maxSizeInKB']);
  const validFormats = getIn(values, ['data', 'validFormat']); // convert to string

  return (
    <FileWrapper>
      <FieldArray
        name="data.validFormat"
        render={({ push, remove }) => (
          <Types>
            {Object.keys(definedTypes).map((key) => (
              <div key={key}>
                <Input
                  id={key}
                  name="data.validFormat"
                  type="checkbox"
                  value={key}
                  label={i18n.t(`${key}`, { ns: 'survey' }) as string}
                  checked={validFormats && validFormats.includes(key)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      push(key);
                    } else {
                      const index = validFormats.indexOf(key);
                      remove(index);
                    }
                  }}
                />
              </div>
            ))}
          </Types>
        )}
      />
      <Sizes>
        <Field name="data.maxSizeInKB">
          {({ form }: FieldProps) => (
            <ButtonGroup
              items={sizeItems}
              selected={(maxSize && maxSize + '') || '512'}
              onSelect={(size) => form.setFieldValue('data.maxSizeInKB', size)}
            />
          )}
        </Field>
      </Sizes>
    </FileWrapper>
  );
};

export default memo(connectFormik<any, IFormValues>(FileFieldsEditor));
